import Theme from '../theme';

/**
 * Create the action
 */

const { thunk, request, success, error } = Theme.store((data, fetch) => {

    // Prepare request
    let formData = new FormData();

    Object.keys(data).map(function(key) {

        if(key == 'image') {
            if(data[key].constructor === File) {
                formData.append(key, data[key]);
            }
        } else if(key == 'public') {
            formData.append(key, data[key] == false ? 0 : 1);
        } else if(key == 'categories') {
            formData.append(key, JSON.stringify(data[key]));
        }
        else {
            formData.append(key, data[key]);
        }
        
    });

    return fetch.post('/themes', formData);
});

/**
 * Export the components
 */

export { thunk as default };
export { request, success, error };
